import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InfiniteScrollService {
  private scrollSignalSource = new Subject<void>();
  public scrollSignalData: Observable<void> =
    this.scrollSignalSource.asObservable();

  constructor() {}

  signalScroll() {
    this.scrollSignalSource.next();
  }
}
